import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AppState } from "src/app/state/app.state";
import { ProductLocationsBase } from "./product-locations-base";
import { TranslateService } from "@ngx-translate/core";
import { PopperStateService } from 'src/app/_services/popper-state.service';
import { Subject } from 'rxjs';

@Component({
  selector: "product-locations-info",
  templateUrl: "./product-locations-info.component.html",
  styleUrls: ["./product-locations.scss"],
})
export class ProductLocationsInfoComponent
  extends ProductLocationsBase
{
  @Input() public validationUrl: string | null = null;
  @Input() public retailerName: string;

  @ViewChild('tooltipcontent') tooltipcontent: any;

  public isTooltipOpen = false;
  private destroy$ = new Subject<void>();

  constructor(
    private _appState: AppState,
    _translateService: TranslateService,
    private popperStateService: PopperStateService
  ) {
    super(_translateService);
  }

  public get hasSubscription(): boolean {
    return this._appState.hasSubscription;
  }

  public navigateToProductValidation() {
    if (this.validationUrl) {
      window.open(this.validationUrl, "_blank");
    }
  }

  ngOnInit(): void {
    this._calculateLocationData();
  }


  public onPopperShown() {
    this.isTooltipOpen = true;
    this.popperStateService.registerOpenPopper(this.tooltipcontent);
  }

  public onPopperHidden() {
    this.isTooltipOpen = false;
  }
}